import { GET_CLIENT_NAME } from './mutation-types'

export default {
  [GET_CLIENT_NAME]: (state, clientName) => {
    state.clientName = clientName
  },
}
